// extracted by css-extract-rspack-plugin
export default {"cls1":"SingularMentionCitationModal-cls1_KIX","cls2":"SingularMentionCitationModal-cls2_sCR SingularMentionCitationModal-cls1_KIX"};